/*eslint @typescript-eslint/no-explicit-any: 0*/
import { ActionTree, CommitOptions, DispatchOptions, GetterTree, Module, MutationTree, Store } from 'vuex';
import { TypedActions, TypedGetters, TypedMutations } from './CustomFundamentalStoreContracts';

export class VuexModuleFactory<
  State,
  RootState,
  Actions extends Record<keyof Actions, (...args: any) => any>,
  Mutations extends Record<keyof Mutations, (...args: any) => any>,
  Getters extends Record<keyof Getters, (...args: any) => any> = any
> {
  // public module = namespace(this.moduleName); // Not used for now

  public state: State;
  public getters!: TypedGetters<Getters>;
  private mutations!: TypedMutations<Mutations>;
  private actions!: TypedActions<Actions>;
  private rootStore!: Store<RootState>;

  constructor(
    public moduleName: string,
    initialState: State,
    private storeOptions: {
      mutations?: MutationTree<State>;
      actions?: ActionTree<State, RootState>;
      getters?: GetterTree<State, RootState>;
    },
  ) {
    this.state = initialState;
  }

  public setRootStore(rootStore: Store<RootState>) {
    this.rootStore = rootStore;
    this.initializeActions();
    this.initializeGetters();
    this.initializeMutations();
  }

  public getModule(): Module<State, RootState> {
    return {
      namespaced: true,
      ...this.storeOptions,
      state: this.state,
    };
  }

  public get dispatch() {
    return this.actions;
  }

  public get commit() {
    return this.mutations;
  }

  private initializeActions() {
    this.validateRootStore();

    this.actions = Object.keys(this.storeOptions.actions || {}).reduce((acc, curr) => {
      acc[curr] = (payload?: any, options?: DispatchOptions) =>
        this.rootStore.dispatch(`${this.moduleName}/${curr}`, payload, options);
      return acc;
    }, {} as any);
  }

  private initializeGetters() {
    this.validateRootStore();

    this.getters = Object.keys(this.storeOptions.getters || {}).reduce((acc, curr) => {
      acc[curr] = (param?: any) => {
        return param
          ? this.rootStore.getters[`${this.moduleName}/${curr}`](param)
          : this.rootStore.getters[`${this.moduleName}/${curr}`];
      };
      return acc;
    }, {} as any);
  }

  private initializeMutations() {
    this.validateRootStore();

    this.mutations = Object.keys(this.storeOptions.mutations || {}).reduce((acc, curr) => {
      acc[curr] = (payload?: any, options?: CommitOptions) =>
        this.rootStore.commit(`${this.moduleName}/${curr}`, payload, options);
      return acc;
    }, {} as any);
  }

  private validateRootStore() {
    if (!this.rootStore) {
      throw new Error('rootStore not initialised correctly. Set the rootstore before using this module');
    }
  }
}
